<template>
  <stripe-bridge-dialog :open="open" :title="item ? 'Metadata of ' + item.name : 'Metadata'" :busy="busy" @close="$emit('cancel')">
    <p v-if="mode">
      <aha-status-badge size="sm" :look="mode === 'live' ? 'alert' : 'quiet'">{{ mode === 'live' ? 'LIVE' : 'TEST' }} mode</aha-status-badge>
    </p>
    <p class="bridge-muted">Keys you remove are unset in Stripe. Values are saved as text.</p>
    <stripe-bridge-metadata-rows
      v-if="open"
      :original="original"
      :busy="busy"
      :empty-text="emptyText"
      @change="rowsState = $event"
    ></stripe-bridge-metadata-rows>
    <aha-alert v-if="error" type="error" size="small">{{ error }}</aha-alert>
    <template slot="footer">
      <aha-button variant="secondary" :disabled="busy" @click="$emit('cancel')">Cancel</aha-button>
      <aha-button :disabled="busy || !canSave" :loading="busy" @click="save">Save metadata</aha-button>
    </template>
  </stripe-bridge-dialog>
</template>

<script>
import nativeAhaElements from './nativeAhaElements'
import StripeBridgeDialog from './StripeBridgeDialog'
import StripeBridgeMetadataRows from './StripeBridgeMetadataRows'

export default {
  name: 'StripeBridgeMetadataEditor',
  components: { ...nativeAhaElements, StripeBridgeDialog, StripeBridgeMetadataRows },
  props: {
    open: { type: Boolean, default: false },
    mode: { type: String, default: '' },
    item: { type: Object, default: null },
    emptyText: { type: String, default: 'No metadata yet.' },
    busy: { type: Boolean, default: false },
    error: { type: String, default: '' },
  },
  data() {
    return { rowsState: null }
  },
  computed: {
    original() {
      return (this.item && this.item.metadata) || {}
    },
    canSave() {
      return !!this.rowsState && !this.rowsState.validationError && this.rowsState.changed
    },
  },
  methods: {
    save() {
      if (!this.canSave) return
      this.$emit('save', this.rowsState.payload)
    },
  },
}
</script>

<style lang="scss" scoped>
@import './bridgeStyles.scss';
</style>
